import { Button } from '@/src/components/Commons/Button';
import TokenInputController from '@/src/components/Commons/Controllers/TokenInputController/TokenInputController';
import LoaderButton from '@/src/components/Commons/LoaderButton/LoaderButton';
import { CLOSE } from "@/src/lib/SmartDB/Commons/Constants/images";
import styles from './InputTokensModal.module.scss';
import useInputTokensModal, { InputTokensModalProps } from './useInputTokensModal';

export default function InputTokensModal(props: InputTokensModalProps) {
    //--------------------------------------
    const {
        isMaxAmountLoaded,
        isTokensStoreReady,
        tokensStore,
        walletStore,
        isOpen,
        fund,
        isDeposit,
        inputTokens,
        inputTokensStr,
        setInputTokens,
        isValidInputTokens,
        isValidInputTokensLessThanExisting,
        isTokensAvailableInUserWallet,
        isFocus,
        isValidInputToken,
        setInputToken,
        handleFocus,
        handleBlur,
        handleMin,
        getMax,
        handleMax,
        isOpenModal,
        handleClose,
        handleConfirm,
        handleOpen,
    } = useInputTokensModal(props);
    //--------------------------------------
    return (
        <>
            {/* amount_Tokens_Available_In_Wallet
            <br />
            {toJson(amount_Tokens_Available_In_Wallet, 2)}
            <br />
            amount_Tokens_Available_In_Wallet_Based_On_FT
            <br />
            {toJson(amount_Tokens_Available_In_Wallet_Based_On_FT, 2)}
            <br /> */}
            <section className={styles.inputSection}>
                <>
                    {walletStore.isConnected === true &&
                    isMaxAmountLoaded === true &&
                    isTokensStoreReady === true &&
                    tokensStore.isAddingTokens === false &&
                    isValidInputTokensLessThanExisting !== undefined &&
                    isTokensAvailableInUserWallet !== undefined ? (
                        isValidInputTokensLessThanExisting === true ? (
                            <Button mode={'outline-sqr'} error={isValidInputTokens === false} size="very-large" onClick={handleOpen} arrow={false}>
                                <div className={styles.flexCol}>
                                    <div className={styles.btnText}>{isDeposit ? `TOKENS YOU GIVE:` : `TOKENS YOU GET:`} </div>
                                    <div className={styles.btnTitle}>{inputTokensStr}</div>
                                </div>
                            </Button>
                        ) : isTokensAvailableInUserWallet === true ? (
                            <Button mode={'outline-sqr'} error={isValidInputTokens === false} size="very-large" onClick={handleOpen} arrow={false}>
                                <div className={styles.btnTitle}>{isDeposit ? `SELECT TOKENS YOU GIVE` : `SELECT TOKENS YOU GET`}</div>
                            </Button>
                        ) : (
                            <Button mode={'outline-sqr'} error={true} disabled={true} arrow={false} size="very-large">
                                <div className={styles.btnText}>Not enough tokens in your wallet</div>
                            </Button>
                        )
                    ) : walletStore.isConnected === true ? (
                        <Button mode={'outline-sqr'} disabled={true} arrow={false} size="very-large">
                            <LoaderButton />
                            <div className={styles.btnTitle}>{isDeposit ? `SELECT TOKENS YOU GIVE` : `SELECT TOKENS YOU GET`}</div>
                        </Button>
                    ) : (
                        <Button mode={'outline-sqr'} disabled={true} arrow={false} size="very-large">
                            <div className={styles.btnTitle}>{`CONNECT WALLET`}</div>
                        </Button>
                    )}
                </>
            </section>
            {isOpenModal === true ? (
                <div className={styles.modal}>
                    <div className={styles.main}>
                        <div className={styles.popUp}>
                            <header className={styles.headerModal}>
                                <h2 className={styles.titleModal}>{isDeposit ? `HOW MANY TOKENS YOU GIVE` : `HOW MANY TOKENS YOU GET`}</h2>
                                <svg width="45" height="45" className={styles.icon} onClick={handleClose}>
                                    <use href={CLOSE}></use>
                                </svg>
                            </header>
                            <p className={styles.inputTokensTitle}>Choose the amount</p>
                            <div className={styles.inputTokensContainer}>
                                {inputTokens.map((token, index) => (
                                    <div key={index}>
                                        <TokenInputController
                                            CS={`${token.CS}`}
                                            TN_Hex={`${token.TN_Hex}`}
                                            ticker={token.ticker}
                                            image={token.image}
                                            value={token.amount}
                                            setValue={(value) => setInputToken(index, value)}
                                            min={0n}
                                            max={getMax(index)}
                                            decimals={token.decimals}
                                            isValidInput={isValidInputToken(index)}
                                        />
                                    </div>
                                ))}
                            </div>
                            <div className={styles.btnGroup}>
                                <Button mode="outline" width={'100%'} arrow={false} onClick={handleConfirm} disabled={!isValidInputTokensLessThanExisting}>
                                    SELECT
                                </Button>
                                <Button onClick={handleClose} mode="link" width={55}>
                                    CANCEL
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            ) : null}
        </>
    );
}
